import React from 'react';

import { Helmet } from 'react-helmet';
import { Route, Routes, useParams } from 'react-router-dom';

import { Box, Card, Container, Stack } from '@mui/material';

import TourDynamicPricingDetailsForm from '~/components/Tours/TourDetails/Forms/TourDynamicPricingDetailsForm';
import TourPricingDetailsForm from '~/components/Tours/TourDetails/Forms/TourPricingDetailsForm';

import TourCampaignScheduleDetailsForm from '../TourDetails/Forms/TourCampaignScheduleDetailsForm';
import TourFinePrintDetailsForm from '../TourDetails/Forms/TourFinePrintDetailsForm';
import TourImagesDetailsForm from '../TourDetails/Forms/TourImagesDetailsForm';
import TourInventoryDetailsForm from '../TourDetails/Forms/TourInventoryDetailsForm';
import TourItinerariesDetailsForm from '../TourDetails/Forms/TourItinerariesDetailsForm';
import TourOptionalExtrasDetailsForm from '../TourDetails/Forms/TourOptionalExtrasDetailsForm';
import TourOptionsDetailsForm from '../TourDetails/Forms/TourOptionsDetailsForm';
import TourRootDetailsForm from '../TourDetails/Forms/TourRootDetailsForm';
import TourTravellerRequirementsDetailsForm from '../TourDetails/Forms/TourTravellerRequirementsDetailsForm';
import TourAccommodationAddOns from '../TourDetails/TourAccommodationAddOns';
import { TourDetailsContextProvider } from '../TourDetails/TourDetailsContext';
import TourDetailsNav from '../TourDetails/TourDetailsNav';
import TourDetailUserReviews from '../TourDetails/TourDetailsUserReviews';
import TourRecentlyViewedProductTracker from '../TourDetails/TourRecentlyViewedProductTracker';

export default function TourDetailsPage() {
  const { tour_id } = useParams<{ tour_id: string }>();

  return (
    <TourDetailsContextProvider>
      <TourRecentlyViewedProductTracker tourId={tour_id} />
      <Helmet>
        <title>Tours | V2 | Details</title>
      </Helmet>
      <Container maxWidth={false}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={2}>
          <Box width={{ sm: 200, lg: 240, xl: 280 }} flexShrink={0}>
            <Card sx={{ position: 'sticky', top: 16 }}>
              <TourDetailsNav tourId={tour_id} />
            </Card>
          </Box>
          <Stack direction="column" flexGrow={1}>
            <Routes>
              <Route index element={<TourRootDetailsForm tourId={tour_id} />} />
              <Route path="tour-options" element={<TourOptionsDetailsForm tourId={tour_id} />} />
              <Route path="tour-itineraries" element={<TourItinerariesDetailsForm tourId={tour_id} />} />
              <Route path="tour-images" element={<TourImagesDetailsForm tourId={tour_id} />} />
              <Route path="tour-pricing" element={<TourPricingDetailsForm tourId={tour_id} />} />
              <Route path="tour-dynamic-pricing" element={<TourDynamicPricingDetailsForm tourId={tour_id} />} />
              <Route path="fine-print" element={<TourFinePrintDetailsForm tourId={tour_id} />} />
              <Route
                path="traveller-requirements"
                element={<TourTravellerRequirementsDetailsForm tourId={tour_id} />}
              />
              <Route path="campaign-schedule" element={<TourCampaignScheduleDetailsForm tourId={tour_id} />} />
              <Route path="inventory" element={<TourInventoryDetailsForm tourId={tour_id} />} />
              <Route path="optional-extras" element={<TourOptionalExtrasDetailsForm tourId={tour_id} />} />
              <Route path="user-reviews" element={<TourDetailUserReviews tourId={tour_id} />} />
              <Route path="add-ons/accommodation" element={<TourAccommodationAddOns tourId={tour_id} />} />
            </Routes>
          </Stack>
        </Stack>
      </Container>
    </TourDetailsContextProvider>
  );
}
